// extracted by mini-css-extract-plugin
export default {"link":"HK-z","disabled":"IK-z"};